export const RESULT_PENDING = 'pending'
export const RESULT_SUCCESS = 'success'
